var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel"},_vm._l((_vm.gameChunk),function(chunk,index){return _c('el-row',{key:index,attrs:{"gutter":20}},_vm._l((chunk),function(user){return _c('el-col',{key:user.id,attrs:{"span":8}},[_c('user-card',{attrs:{"user":user,"role":_vm.userRole,"disable":_vm.disable,"current-role":_vm.currentRole}})],1)}),1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }